import { createSelector } from '@reduxjs/toolkit'
import { Service } from '@/models/service'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'
import { cartSlice } from '..'

export const selectedElementQuotableProductsQuantitySelector = createSelector(
  [
    cartSlice.selectors.selectedElementQuotableProducts,
    (_state: unknown, service: Service) => service,
  ],
  (selectedElementQuotableProducts, service): number => {
    return getBoughtServicesTotal(
      selectedElementQuotableProducts.boughtServices[service.serviceId]
    )
  }
)
